export const Global = {
  DEFAULT_FILTER: {
    page: 1,
    size: 20,
    keyword: "",
  },
  DEFAULT_PAGINATION: 20,
};
